/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  fetchRecipientsBuildingTypesRequest,
  fetchRecipientsClientAddressesRequest,
  fetchRecipientsCommitteesRequest,
} from 'shared/store/sendMessage/recipients'
import {
  getMessageRecipients,
  getRecipientsCommittees,
} from 'shared/store/sendMessage/recipients/selectors'
import { FilterTypeEnum } from '../models/Recipients'

const useInitRecipientsFilters = () => {
  const dispatch = useDispatch()
  const { filters } = useSelector(getMessageRecipients)

  const { data: committees } = useSelector(getRecipientsCommittees)

  useEffect(() => {
    dispatch(fetchRecipientsClientAddressesRequest())
    dispatch(fetchRecipientsBuildingTypesRequest())
  }, [])

  useEffect(() => {
    if (
      filters.filterType === FilterTypeEnum.BoardMembers &&
      !committees?.length
    ) {
      dispatch(fetchRecipientsCommitteesRequest())
    }
  }, [dispatch, filters.filterType, filters.boardId])
}

export default useInitRecipientsFilters
